<div class="h-100">
        <ng2-pdfjs-viewer  #pdfViewer [print]="config.print" [downloadFileName]="config.document_name" [openFile]="false" [sidebar]="false"></ng2-pdfjs-viewer>
</div>
